<div class="cookie-policy-container">
  <h1>{{ 'COOKIE_POLICY.TITLE' | translate }}</h1>

  <p [innerHTML]="'COOKIE_POLICY.INTRO' | translate"></p>

  <h2>{{ 'COOKIE_POLICY.SECTION_TYPES.TITLE' | translate }}</h2>

  <h3>{{ 'COOKIE_POLICY.SECTION_NECESSARY.TITLE' | translate }}</h3>
  <p>{{ 'COOKIE_POLICY.SECTION_NECESSARY.TEXT' | translate }}</p>

  <h3>{{ 'COOKIE_POLICY.SECTION_ANALYTICS.TITLE' | translate }}</h3>
  <p>{{ 'COOKIE_POLICY.SECTION_ANALYTICS.TEXT1' | translate }}</p>
  <p [innerHTML]="'COOKIE_POLICY.SECTION_ANALYTICS.TEXT2' | translate"></p>

  <h3>{{ 'COOKIE_POLICY.SECTION_MARKETING.TITLE' | translate }}</h3>
  <p>{{ 'COOKIE_POLICY.SECTION_MARKETING.TEXT1' | translate }}</p>
  <p [innerHTML]="'COOKIE_POLICY.SECTION_MARKETING.TEXT2' | translate"></p>

  <h2>{{ 'COOKIE_POLICY.SECTION_MANAGE.TITLE' | translate }}</h2>
  <p>{{ 'COOKIE_POLICY.SECTION_MANAGE.TEXT' | translate }}</p>
  <ul>
    <li><a href="https://support.google.com/chrome/answer/95647?hl=hu" target="_blank">Google Chrome</a></li>
    <li><a href="https://support.mozilla.org/hu/kb/sutik-torlese" target="_blank">Mozilla Firefox</a></li>
    <li><a href="https://support.microsoft.com/hu-hu/microsoft-edge/sütik-törlése-az-edge-ben" target="_blank">Microsoft Edge</a></li>
    <li><a href="https://support.apple.com/hu-hu/guide/safari/sfri11471/mac" target="_blank">Safari</a></li>
  </ul>

  <h2>{{ 'COOKIE_POLICY.SECTION_CONTROLLER.TITLE' | translate }}</h2>
  <p [innerHTML]="'COOKIE_POLICY.SECTION_CONTROLLER.TEXT' | translate"></p>

  <p class="last-updated">{{ 'COOKIE_POLICY.LAST_UPDATED' | translate }}</p>
</div>
